import { CONTACT_ANSWER_PHONE_SUFFIX, SUPPORT_EMAIL, SUPPORT_EMAIL_HREF } from "./contact";
import { PRODUCTION_FACILITY, SEAT_TIER } from "./packaging";
import { TRADEMARK, link, type Copy } from "./types";

export type FaqEntry = {
  readonly id: string;
  readonly question: Copy;
  readonly answer: Copy;
};

export const FAQ_LABEL = "Frequently asked questions";

export const FAQ: readonly FaqEntry[] = [
  {
    id: "what-is-loop",
    question: ["What exactly is LOOP", TRADEMARK, "?"],
    answer: [
      "LOOP is VARIANT3D's design software for knitted products. You bring 3D geometry, design directly on it, and LOOP produces production-ready knit data for prototyping and manufacturing validation.",
    ],
  },
  {
    id: "supported-files",
    question: ["What files can I bring in?"],
    answer: [
      "OBJ and .3dm files. Suitability still depends on geometry, scale, materials and manufacturing requirements.",
    ],
  },
  {
    id: "need-factory",
    question: ["Do I need my own factory or machines?"],
    answer: [
      `No factory required. LOOP gives designers access to embedded manufacturing knowledge and VARIANT3D's production expertise. On a ${SEAT_TIER} Seat, we can support prototyping at our facility; if you run your own machines, that same seat adds machine-data export for your factories.`,
    ],
  },
  {
    id: "machine-file",
    question: ["Do I get the machine file?"],
    answer: [
      `LOOP generates knit-ready machine data either way. Exporting starts on a ${SEAT_TIER} Seat for teams integrating LOOP with their own or partnering factories. Physical production still accounts for machine setup, yarn behavior, finishing and quality validation; we can also support prototyping at ${PRODUCTION_FACILITY}.`,
    ],
  },
  {
    id: "first-sample",
    question: ["How fast is a first sample?"],
    answer: [
      "LOOP can regenerate knit-ready data in seconds after a design change. Prototype timing depends on machine setup, yarn behavior, finishing and production validation.",
    ],
  },
  {
    id: "contact",
    question: ["Who do I contact with questions?"],
    answer: ["Email ", link(SUPPORT_EMAIL, SUPPORT_EMAIL_HREF), CONTACT_ANSWER_PHONE_SUFFIX],
  },
];
